export enum UserRoles {
  LOGISTIC_COORDINATOR = 'LOGISTIC_COORDINATOR',
  SUBCONTRACTOR = 'SUBCONTRACTOR',
  SECURITY_GUARD = 'SECURITY_GUARD',
  EQUIPMENT_OPERATOR = 'EQUIPMENT_OPERATOR',
  TRAFFIC_MARSHALL = 'TRAFFIC_MARSHALL',
  SUPPLIER = 'SUPPLIER',
}
